import {useMemo} from "react";
import {useApiCall} from "./useApiCall";
import {parseParameterComparisons} from "./parse";
import {ParameterComparison} from "./types/ParameterComparison";
import {buildFilterQueryString} from "./utils";

interface Arguments {
    comparisonJobId: string;
    locale: string;
    facet: string;
}

interface Return {
    comparisonResults: ParameterComparison[];
    loading: boolean;
    error: string | null;
    refetch: () => void;
}

export function useParameterComparisonResultsForJob(args: Arguments): Return {
    const baseUrl = `/api/parameterComparisonJobs.getComparisonResultsForJob`;
    const {comparisonJobId, locale, facet} = args;
    const queryString = buildFilterQueryString(comparisonJobId, locale, facet);
    const url = `${baseUrl}?${queryString}`;

    const {data, error, loading, refetch} = useApiCall(url);

    const comparisonResults = useMemo(() => {
        if (data) {
            return parseParameterComparisons(data);
        }
        return [];
    }, [data]);

    return {
        comparisonResults,
        loading,
        error,
        refetch
    };
}
